import { Component } from '@angular/core';
import { AuthyTicketTypeEnum } from '@nttp/enum/authy-ticket-type.enum';
import { SendPaymentInstructionService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.service';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { ToastrService } from 'ngx-toastr';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { RecipientService } from '@pg-app/client/manage-recipient/services/recipient.service';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { VerifyCodeErrorEnum } from '@nttp/enum/verify-code-error-type.enum';
import { format } from 'date-fns';
import { ShareService } from '@nttp/common-service/share-service';

@Component({
  selector: 'np-validate-payment',
  templateUrl: './validate-payment.component.html',
  styleUrls: ['./validate-payment.component.scss']
})
export class ValidatePaymentComponent {
  btnName = 'Continue';
  pinCodeError = null;
  ticketType = AuthyTicketTypeEnum.SendPaymentInstruction;
  sendOnetouchSuccess = false;

  constructor(
    private sendPaymentInstructionService: SendPaymentInstructionService,
    public sendPaymentModel: SendPaymentInstructionModelService,
    private toasterService: ToastrService,
    public registerService: RegistrationStep2Service,
    private recipientService: RecipientService,
    private shareService: ShareService,
  ) {}

  confirmPassCode(event = null) {
    this.pinCodeError = null;
    const code = event ? event.code : null;
    const type = event ? event.verificationType : VerifyTypeSendCodeEnum.Onetouch;
    let verifyPassCode;
    if (type === VerifyTypeSendCodeEnum.Sms) {
      verifyPassCode = this.recipientService.verificationCodePayment(code, type, this.sendPaymentModel.twillioActionId);
    } else {
      verifyPassCode = this.recipientService.verificationPassCode(code, type);
    }

    verifyPassCode.subscribe(
      res => {
        if (res.succeeded) {
          const uuid = type === VerifyTypeSendCodeEnum.Onetouch ? res.uuid : this.sendPaymentModel.twillioActionId;
          if (this.sendPaymentModel.processWithMandate) {
            this.proccessMandate(uuid);
          } else {
            this.makePayment(uuid);
          }
        } else {
          this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
        }
      },
      err => {
        this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
      }
    );
  }

  proccessMandate(uuid) {
    this.shareService.reasonForPaymentList$.subscribe(res => {
      const rfpOther = res.find(item => item.name === 'Others');

      const param = {
        currencyId: this.sendPaymentModel.currency.id,
        amount: parseFloat(this.sendPaymentModel.amount),
        receipientId: this.sendPaymentModel.recipientMandate.id,
        paymentDate: this.sendPaymentModel.paymentDate,
        reasonForPaymentId: rfpOther.id,
        paymentReference: this.sendPaymentModel.paymentReference !== null && this.sendPaymentModel.paymentReference !== '' ? this.sendPaymentModel.paymentReference : 'Mandate Payment' ,
        reasonForPaymentText: rfpOther.name.concat(': Mandate Payment'),
        tradeIds: [].concat(this.sendPaymentModel.tradeId),
        paymentDateString: format(this.sendPaymentModel.paymentDate, 'YYYYMMDD'),
        verificationSID: uuid
      };
      this.sendPaymentInstructionService.insertClientPayment(param).subscribe(
        data => {
          this.sendPaymentModel.paymentId = data;
          this.sendPaymentModel.step = this.sendPaymentModel.sendPaymentStep.paymentComplete;
        }
      );
    });
  }

  makePayment(uuid) {
    const paymentForm = {
      currencyId: this.sendPaymentModel.currency.id,
      amount: parseFloat(this.sendPaymentModel.amount),
      receipientId: this.sendPaymentModel.selectedRecipient.id,
      ultimateRemitterId: this.sendPaymentModel.ultimateRemitterId,
      paymentDate: this.sendPaymentModel.paymentDate,
      reasonForPaymentId: this.sendPaymentModel.reasonPayment.id,
      reasonForPaymentText:
        this.sendPaymentModel.reasonPayment.name === 'Others'
          ? this.sendPaymentModel.reasonPaymentOther
          : this.sendPaymentModel.reasonPayment.name,
      paymentReference: this.sendPaymentModel.paymentReference,
      tradeIds: this.sendPaymentModel.tradeFundPayment,
      drawdownTrades: this.sendPaymentModel.tradeDrawdown,
      paymentDateString: format(this.sendPaymentModel.paymentDate, 'YYYYMMDD'),
      clientId: null,
      purposeOfPaymentCodeId: this.sendPaymentModel.purposePaymentIdSelected,
      externalPaymentId: this.sendPaymentModel.externalPaymentId,
      verificationSID: uuid
    };

    this.sendPaymentInstructionService.insertClientPayment(paymentForm).subscribe(
      data => {
        this.sendPaymentModel.paymentId = data;
        this.sendPaymentModel.step = this.sendPaymentModel.sendPaymentStep.paymentComplete;
      }
    );
  }

  sendCode(event = null) {
    this.pinCodeError = null;
    const param = {
      currencyCode: this.sendPaymentModel.currency.code,
      amount: parseFloat(this.sendPaymentModel.amount),
      paymentDate: format(this.sendPaymentModel.paymentDate, 'YYYYMMDD'),
      paymentReference: this.sendPaymentModel.paymentReference
        ? this.sendPaymentModel.paymentReference
        : this.sendPaymentModel.processWithMandate
          ? 'Mandate Payment'
          : '',
      recipientName:
        this.sendPaymentModel.processWithMandate && this.sendPaymentModel.recipientMandate
          ? `${this.sendPaymentModel.recipientMandate.name} (${this.sendPaymentModel.currency.code})`
          : this.sendPaymentModel.selectedRecipient.name,
      verificationType: event ? event.method : VerifyTypeSendCodeEnum.Onetouch
    };

    this.sendPaymentInstructionService.sendPaymentCode(param).subscribe(
      res => {
        this.sendPaymentModel.twillioActionId = res.actionId;
        if (event && event.isTryAgain) {
          this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
        }
        if (!event) {
          this.sendOnetouchSuccess = true;
        }
      }
    );
  }
}
